/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_DocumentsInputs */

const en_inbound_field_documents = /** @type {(inputs: Inbound_Field_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Inbound_Field_DocumentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_documents = /** @type {((inputs?: Inbound_Field_DocumentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_DocumentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_documents(inputs)
});